var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "toolbar-slide" } }, [
    _vm.isToolbarVisible
      ? _c("div", { staticClass: "emails-toolbar-container" }, [
          _c(
            "div",
            { staticClass: "emails-toolbar" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "typographies-paragraph-medium-bold btn-cancel-selected-items"
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close", variant: "contrast" },
                    on: { click: _vm.closeToolbar }
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.n__(
                          "common.labels.selected",
                          null,
                          _vm.selectedEmails.length,
                          _vm.selectedEmails.length
                        )
                      ) +
                      "\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "email.listings.EmailListingActions.add_related"
                  ),
                  type: "tertiary-contrast",
                  leftIcon: "objects-linked"
                },
                on: { click: _vm.handleUpdateRelated }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }